import { serverTimestamp, setDoc } from 'firebase/firestore';
import type { UserProfile } from '../App';
import { activityFeedDoc } from '../db';

export type ActivityType =
  | 'question'
  | 'mood'
  | 'night_note'
  | 'instant_photo'
  | 'heartbeat'
  | 'pet_care'
  | 'pet_ritual';

interface ActivityInput {
  type: ActivityType;
  title: string;
  body?: string;
  dayKey?: string;
  sourceId?: string;
}

export interface ActivityFeedItem {
  id: string;
  type: ActivityType | string;
  actorId: string;
  actorName: string;
  title: string;
  body?: string;
  createdAt?: any;
  updatedAt?: any;
  dayKey: string;
  sourceId: string;
}

export function getTodayKey() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

function safeId(value: string) {
  return value
    .toLocaleLowerCase('tr-TR')
    .replace(/[^a-z0-9ğüşöçıİĞÜŞÖÇ_-]+/gi, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 140);
}

export async function recordActivity(user: UserProfile, input: ActivityInput) {
  const dayKey = input.dayKey || getTodayKey();
  const sourceId = input.sourceId || user.uid;
  const id = safeId(`${dayKey}-${input.type}-${sourceId}`);

  await setDoc(activityFeedDoc(user.coupleId, id), {
    type: input.type,
    actorId: user.uid,
    actorName: user.displayName,
    title: input.title,
    body: input.body || '',
    dayKey,
    sourceId,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  }, { merge: true });
}
